import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "../i18n";
import { usePageTitle } from "../hooks/usePageTitle";
import ZoneStorageSelectLocation from "../components/zone-storage-select-location";
import ZoneStorageSorter1 from "../components/zone-storage-sorter-1";
import ZoneStorageSorter2 from "../components/zone-storage-sorter-2";
import ZoneStorageSorter1Unload from "../components/zone-storage-sorter-1-unload";
import ZoneStorageSorter2Unloader from "../components/zone-storage-sorter-2-unloader";
import ZoneStoragePickAndSort, { type PickAndSortSession } from "../components/zone-storage-pick-and-sort";

import "../styles/zonestorage.css";
import "../styles/scansheet.css";


const ZoneStorage = () => {
    usePageTitle("zone_storage");
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [userLocation, set_userLocation] = useState<{ warehouse: string, sorter: string, bay: string }>({ warehouse: "", sorter: "", bay: "" });
    const [pickAndSortSession, set_pickAndSortSession] = useState<PickAndSortSession | null>(null);

    const resetSettings = () => {
        set_userLocation({ warehouse: "", sorter: "", bay: "" });
        set_pickAndSortSession(null);
    };

    // Pick & Sort process — entered by scanning a configured bay-location
    // barcode (resolved server-side, distinct from the Sorter 1/2 WWSSBB code).
    if (pickAndSortSession) {
        // key on wave_id so loading the next wave remounts with fresh state.
        return <ZoneStoragePickAndSort key={pickAndSortSession.wave_id} session={pickAndSortSession} resetFunc={resetSettings} onWaveChange={set_pickAndSortSession} />;
    }

    // Location selector — uses scan-panel for full-screen centred layout
    if (userLocation.warehouse === "") {
        return <ZoneStorageSelectLocation set_userLocation={set_userLocation} onPickAndSort={set_pickAndSortSession} />;
    }

    // Scan sub-pages — render directly (no page-data wrapper)
    if (userLocation.sorter === "1") {
        return <ZoneStorageSorter1 warehouse={userLocation.warehouse} bay={userLocation.bay} resetFunc={resetSettings} />;
    }
    if (userLocation.sorter === "2") {
        return <ZoneStorageSorter2 warehouse={userLocation.warehouse} bay={userLocation.bay} resetFunc={resetSettings} />;
    }
    if (userLocation.sorter === "3") {
        return <ZoneStorageSorter1Unload warehouse={userLocation.warehouse} resetFunc={resetSettings} />;
    }
    if (userLocation.sorter === "4") {
        return <ZoneStorageSorter2Unloader warehouse={userLocation.warehouse} resetFunc={resetSettings} />;
    }

    return null;
};

export default ZoneStorage;
